import React, { useEffect, useState } from "react";
import "./mailbox_styles/middlebar.css";
import MailCard from "./MailCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom";
import { emailsRef } from "../../firebase";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";


const Middlebar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const currentMailOption = currentPath.split("/")[2];
  const openMailId = currentPath.split("/")[3];

  const [emails, setEmails] = useState([]);
  const [filterField, setFilterField] = useState('to');
  const userData = useSelector((state) => state.userData);

  const handleHambargerClick = () => { }

  useEffect(() => {
    if (currentMailOption === "inbox") {
      setFilterField('to');
    } else if (currentMailOption === "sent-mails") {
      setFilterField('from_email');
    }
    emailsRef
      .where(filterField, '==', userData.email)
      .onSnapshot(snapshot => {
        setEmails(snapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        })))
      })
    // eslint-disable-next-line
  }, [currentMailOption, filterField])

  emails.sort((a, b) => {
    const aTimestamp = a.data.timestamp;
    const bTimestamp = b.data.timestamp;
    return bTimestamp - aTimestamp;
  });
  // console.log(emails);
  // console.log(emails.filter(email => !email.data.opened && email.data.to === userData.email).length);

  // After click on email status opened will update
  const handleChangeOpenedState = (docId) => {
    if (currentMailOption === "inbox") {
      emailsRef.doc(docId).update({
        opened: true
      }).then(() => {
        // console.log("Email opened state updated successfully");
      }).catch((error) => {
        console.error("Error updating email opened state: ", error);
      });
    }
  };

  return (
    <>
      <div className="middlebar_container">
        <div className="search_container">
          <div className="hambargers">
            <FontAwesomeIcon icon={faBars} className="icons" onClick={handleHambargerClick} />
          </div>
          <input placeholder="Search" className="searchBox" style={{ width: "95%" }} />
        </div>
        <div className="mail_crad_container">
          {emails.map((data) => {
            return (
              <Link key={data.id} to={`/mailbox/${currentMailOption}/${data.id}`} className="link" onClick={() => handleChangeOpenedState(data.id)}>
                <MailCard props={data} currentMailOption={currentMailOption} filterField={filterField === 'to' ? 'from_email' : filterField === 'from_email' ? 'to' : ''} />
              </Link>
            );
          })}
        </div>
      </div>
      {
        openMailId ? <Outlet /> :
          <>
            <div className="rightpage_container select_container">
              <h4>Select Any Item To Open</h4>
            </div>
          </>
      }
    </>
  );
};

export default Middlebar;
